export default __webpack_public_path__ + "static/media/Ct11.5b002cc8.png";